"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSelect = _interopRequireDefault(require("react-select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "DropdownFilter__Container",
  componentId: "sc-1436hq2-0"
})(["font-size:1.4rem;margin-bottom:1rem;"]);

var Label = _styledComponents.default.label.withConfig({
  displayName: "DropdownFilter__Label",
  componentId: "sc-1436hq2-1"
})(["font-weight:600;line-height:1.25;"]);

var Content = _styledComponents.default.div.withConfig({
  displayName: "DropdownFilter__Content",
  componentId: "sc-1436hq2-2"
})(["margin-top:1rem;"]);

var DropdownFilter = function DropdownFilter(_ref) {
  var selected = _ref.selected,
      attribute = _ref.attribute,
      name = _ref.name,
      facets = _ref.facets,
      updateFilter = _ref.updateFilter,
      customStyles = _ref.customStyles,
      placeholder = _ref.placeholder;
  if (!facets || facets.length < 1) return null;
  var defaultArgs = {
    checked: false,
    attribute: attribute,
    facets: ''
  };
  var selectedOption = (selected[0] ? facets.find(function (_ref2) {
    var value = _ref2.value;
    return value === selected[0];
  }) : selected[0]) || '';
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(Label, null, name), /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
    className: "selectLocation",
    styles: customStyles,
    value: selectedOption,
    options: facets,
    placeholder: placeholder || 'Select...',
    isClearable: true,
    onChange: function onChange(item) {
      return !item ? updateFilter(defaultArgs) : updateFilter(_objectSpread(_objectSpread({}, defaultArgs), {}, {
        facets: [item.value]
      }));
    }
  })));
};

DropdownFilter.propTypes = {
  attribute: _propTypes.default.string,
  name: _propTypes.default.string,
  facets: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  })),
  selected: _propTypes.default.arrayOf(_propTypes.default.string),
  updateFilter: _propTypes.default.func.isRequired,
  customStyles: _propTypes.default.object,
  placeholder: _propTypes.default.string
};
DropdownFilter.defaultProps = {
  locations: [],
  selected: [],
  customStyles: {}
};
var _default = DropdownFilter;
exports.default = _default;